
























import { Component, Provide, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { HeaderDefault, HeaderSearch, HeaderMenuDesktop, HeaderMenuMobile } from "@/components/header";

@Component({
  components: {
    HeaderDefault,
    HeaderSearch,
    HeaderMenuDesktop,
    HeaderMenuMobile,
  },
  computed: {
    ...mapGetters("ui", ["headerType", "menuVisible"]),
    ...mapGetters("network", ["hasMagistrateEnabled"]),

    menuEntries() {
      const entries = [{ name: "home" }, { name: "top-wallets", params: { page: 1 } }, { name: "delegate-monitor" }];

      entries.push({ name: "advanced-search", params: { page: 1 } });

      return entries;
    },
  },
})
export default class AppHeader extends Vue {
  @Provide("normalizeName") public foo = this.normalizeName;

  private headerType: string;
  private menuVisible: boolean;

  public normalizeName(name: string): string {
    return name.replace("-", "_").toUpperCase();
  }

  private closeHeader(): void {
    this.$store.dispatch("ui/setHeaderType", null);
  }
}
